<template>
    <HeadComp v-if="!isMobile" />
    <HeadMobileComp v-else :title="pageTitle" />
    <div class="main-container" :class="{ 'main-container-mobile': isMobile, 'main-container-custom-header': customHeader }">
        <router-view />
    </div>
</template>

<script>
import HeadComp from '../components/HeadComp.vue';
import HeadMobileComp from '../components/HeadMobileComp.vue';

export default {
    name: "MainLayout",
    components: {
        HeadComp,
        HeadMobileComp,
    },
    data() {
        return {
            width: window.innerWidth,
        };
    },
    computed: {
        isMobile() {
            return this.width < 576;
        },
        pageTitle() {
            return this.$route.meta.title || "Title";
        },
        customHeader() {
            return this.$route.meta.customHeader || false;
        },
    },
    created() {
        window.addEventListener("resize", this.handleResize);
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.handleResize);
    },
    methods: {
        handleResize() {
            this.width = window.innerWidth;
        },
    },
};
</script>

<style scoped>
.main-container {
    background-color: var(--background-light);
    min-height: calc(100vh - 75px);
    padding-top: 40px;
}
.main-container-mobile {
    padding-top: 0;
    background-color: var(--white-color);
}

.main-container-custom-header {
    background-color: var(--background-light) !important;
    padding-top: 40px !important;
}
</style>